import { type HTMLAttributes, forwardRef } from 'react'
import { tagVariants } from './Tag.variants'

export interface TagProps extends HTMLAttributes<HTMLDivElement> {
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
  size?: 'sm' | 'md'
}

export const Tag = forwardRef<HTMLDivElement, TagProps>(
  ({ accentColor = 'none', size = 'md', className, children, ...props }, ref) => {
    return (
      <div className={tagVariants({ accentColor, size, className })} ref={ref} {...props}>
        {children}
      </div>
    )
  }
)

Tag.displayName = 'Tag'
